import { getHealthPlans } from "@/utils/apis/plan-service";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { usePlansStore } from "@/utils/stores/usePlansStore";
import { useCallback, useEffect, useState } from "react";

export const useGetHealthPlan = () => {
    const { auth } = useAuthStore();
    const { updatePlans, plans } = usePlansStore();
    const [isLoading, setIsLoading] = useState(false);

    const fetchHealthPlan = useCallback(async () => {
        const { idToken, userId } = auth;

        if (!idToken || !userId) return;

        try {
            setIsLoading(true);
            const healthPlans = await getHealthPlans(userId, idToken);
            updatePlans({ healthPlans });
        } catch (error) {
            updatePlans({ healthPlans: null });

            if (error instanceof Error) {
                if (error.message.includes("Session expired")) {
                    throw new Error("Session expired");
                } else if (error.message.includes("Nessun health plan trovato")) {
                    throw new Error(error.message);
                }
            }

            throw new Error("Unexpected error on get health plans");

        } finally {
            setIsLoading(false);
        }
    }, [auth, updatePlans]);

    useEffect(() => {
        fetchHealthPlan()
    }, [fetchHealthPlan])

    return {
        healthPlans: plans?.healthPlans ?? null,
        isLoading,
        refetch: fetchHealthPlan,
    }
}